  
export function isLoggedIn() {
  return localStorage.getItem('rtcrobotsecretid') !== null && localStorage.getItem('rtcrobotsecretkey') !== null && localStorage.getItem('rtcrobotrole');
}
